"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EventBufferConfiguration_1 = __importDefault(require("../eventbufferconfiguration/EventBufferConfiguration"));
/**
 * [[EventIngestionConfiguration]] contains necessary information to
 * report events to the ingestion service.
 */
class EventIngestionConfiguration {
    constructor(eventsClientConfiguration, ingestionURL, eventBufferConfiguration = new EventBufferConfiguration_1.default()) {
        this.eventsClientConfiguration = eventsClientConfiguration;
        this.ingestionURL = ingestionURL;
        this.eventBufferConfiguration = eventBufferConfiguration;
    }
}
exports.default = EventIngestionConfiguration;
//# sourceMappingURL=EventIngestionConfiguration.js.map